import { Link, useLocation } from 'react-router-dom';
import { Images } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../AppProvider.tsx';
import useAppLocation from '../useAppLocation.ts';
import type { NavLinkProps } from '@fastnorth/kraken/components/navigation';
import { hasEventGallery } from '../../utils/hasEventGallery';

const usePhotosLink = (): NavLinkProps | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.navigation' });
  const [{ event }] = useApp();
  const { gallery, uniqueCode } = event || {};
  const { isPhotos } = useAppLocation();
  const { search } = useLocation();

  if (!event || !hasEventGallery(gallery)) {
    return null;
  }

  return {
    id: 'photos',
    active: isPhotos,
    children: (
      <Link
        to={`/events/${uniqueCode}/photos${search}`}
        className={'flex items-center'}
        data-dd-action-name={'link-photos-nav_menu'}>
        <Images size={16} strokeWidth={2} className={'mr-4'} />
        {t('photos_label')}
      </Link>
    ),
  };
};

export default usePhotosLink;
